import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => style(theme));

function PanelDivider () {
    const classes = useStyles();
    return (
        <div className={classes.border} />
    );
}

const style = theme => ({
    border: {
        height: '2px',
        backgroundColor: theme.palette.background.border
    }
});

export default PanelDivider;